module.exports = __webpack_public_path__ + "img/github.4c4b970f.svg";